import { SELECT_DEALER } from 'constants/ActionTypes';
import { SELECT_GROUP } from 'modules/groups/actionTypes';
import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string} */
const initialState = null;

const setSelectedQuestionId = (_, { payload }) => payload;

const clearData = () => initialState;

export default createReducer(initialState, {
  [types.SET_QUESTION_MODEL_STATISTICS_ID]: setSelectedQuestionId,
  [types.CLEAR_QUESTION_MODEL_STATISTIC]: clearData,
  [SELECT_DEALER]: clearData,
  [SELECT_GROUP]: clearData,
});
